import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFire = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "translate(4.1944 24.8723) scale(1 -1)",
		d: "M20.9406 0.889106C22.3055 0.889206 23.1607 2.36318 22.4836 3.54829L13.3489 19.5346C12.6664 20.729 10.9444 20.7289 10.2619 19.5346L1.12717 3.54829C0.450283 2.3633 1.3055 0.889442 2.67014 0.889106H20.9406Z",
		stroke: "currentColor",
		strokeWidth: 1.77778,
		strokeLinejoin: "round"
	})
});
export default SvgFire;
